import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { FormHelperText } from "@mui/material";
import Tooltip from "../Tooltip/Tooltip";

function TextField(props) {
  const {
    label,
    required,
    validation,
    email,
    number,
    error,
    placeholder,
    value,
    handleChange,
    handleValidation,
    helperText,
    count,
    disabled,
    CharAlignMid,
    onkeyDown,
    name,
    showErrorMsg = true,
    InputAdornmentLabel,
    StartAdornment,
    RequiredLabel,
  } = props;

  const [validationError, setValidationError] = useState(false);
  const [validationText, setValidationText] = useState("");

  const handleOnChange = (event) => {
    const value = event.target.value;
    let error = false;

    // required field validation
    if (required && value?.length > 0) {
      setValidationError(false);
      setValidationText("");
    } else {
      error = true;
      setValidationError(true);
      setValidationText("Required");
    }

    // email field validation
    if (email) {
      if (emailValidation(value)) {
        setValidationError(false);
        setValidationText("");
      } else {
        error = true;
        setValidationError(true);
        setValidationText("Enter a valid email address");
      }
    }

    handleChange(value);

    if (handleValidation) {
      handleValidation(error);
    }
  };

  const emailValidation = (email) => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };

  const handleOnInput = (e) => {
    let maxNum = props.count;
    if (e.target.value.length > maxNum) {
      e.target.value = e.target.value.slice(0, maxNum);
    }
  };

  return (
    <div className="TextField">
      {label && (
        <div className="FieldLabelContainer">
          <div className="TextFieldLabelContainer">
            {label} {(required || validation) && <span style={{color:'#BA1A1A'}}>*</span>}
            {props.TooltipStatus && (
              <Tooltip
                TooltipText={props.TooltipText}
                Tooltip={<InfoOutlinedIcon />}
              />
            )}
          </div>
          {RequiredLabel && (
            <div className="RequiredLabel">Required</div>
          )}
        </div>
      )}
      <div className="FieldContainer">
        <div className={CharAlignMid}>
          <FormControl error={error} fullWidth>
            <OutlinedInput
              onInput={handleOnInput}
              id="outlined-basic"
              variant="outlined"
              type={number ? number : "text"}
              error={error}
              placeholder={placeholder}
              value={value}
              name={name}
              onChange={handleOnChange}
              helperText={showErrorMsg && helperText}
              disabled={disabled ? disabled : false}
              inputProps={{
                maxLength: count,
              }}
              onkeyDown={onkeyDown}
              onBlur={props.onBlur}
              style={{ textTransform: "uppercase" }}
              
              
              startAdornment={props.StartAdornment && <InputAdornment position="start">{StartAdornment && <div className="StartAdornment">{StartAdornment}</div> }</InputAdornment>}
            
              
              endAdornment={
                <InputAdornment position="end">
                  {props.InputAdornmentLine && (
                    <div className="InputAdornmentLine"></div>
                  )}{" "}
                  {InputAdornmentLabel}
                  {count && (
                    <span>
                      {!value ? "0" : value.length}/{count}
                    </span>
                  )}
                </InputAdornment>
              }
            />
            {helperText && (
              <FormHelperText id="component-helper-text">
                {helperText}
              </FormHelperText>
            )}
          </FormControl>

          <span className="FieldCount"></span>
        </div>
        <div className="ErrorTooltip">
          {props.ErrorTooltipStatus && (
            <Tooltip
              TooltipText={props.ErrorTooltipText}
              Tooltip={<AnnouncementRoundedIcon />}
            />
          )}
        </div>
      </div>
      {/* temporary disabled by sujan */}
      {/* <a className="AvailableButton">Available?</a> */}
    </div>
  );
}

export default TextField;
